// Description: This file contains functions for logging the page history and redirecting to the previous page.
//
// Refactored to use ES6 syntax and functions.

/**
 * Logs the page history by sending a request to the server.
 */
const logPageHistory = () => {
    if (window.sessionStorage.tabId) {
        window.tabId = window.sessionStorage.tabId;
        window.sessionStorage.removeItem("tabId");
    } else {
        window.tabId = createGuidV4();
    }
    const currentPageUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    callHandler('/Endpoints/PageHistory.ashx', `?fdTabId=${window.tabId}&fdUrl=${currentPageUrl}`, false);
};

/**
 * Redirects to the previous page by sending a request to the server.
 */
const redirectPreviousPage = () => {
    callHandler('/Endpoints/RedirectPreviousPage.ashx', `?fdTabId=${window.tabId}&fdCurrentPageUrl=${window.location.pathname}`, true);
};
